import { useEffect, useState } from 'react';

export function usePageViewReady() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const handleLoad = () => setIsReady(true);

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return isReady;
}
